import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { ELimitValueType } from 'src/app/domain/enum/limit-value-type';
import { Limit } from 'src/app/domain/limit';
import { LimitCategory } from 'src/app/domain/limit-category';
import { StringConverter } from '../string-converter';
import { Configuration } from 'src/app/domain/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-copy-conf-box',
    templateUrl: './copy-conf-box.component.html',
    styleUrl: './copy-conf-box.component.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule, FormsModule, MatOptionModule, MatButtonModule, PreventDoubleClickDirective]
})
export class CopyConfBoxComponent implements OnInit, AfterContentInit {
    public LimitValueTypeList: string[] = Object.values(ELimitValueType)
        .filter(x => !isNaN(Number(x)))
        .map(x => StringConverter.getLimitValueTypeName(x as ELimitValueType));
    AvailableConfigurationList: Configuration[] = [];
    SelectedConfiguration?: Configuration;

    constructor(
        private configurationService: ConfigurationService,
        public dialogRef: MatDialogRef<CopyConfBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
        }
    }
    
    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        this.getMasterList()
    }

    getMasterList() {
        this.configurationService.GetAvailableMasterList().subscribe(x => {
            this.AvailableConfigurationList = x;
        })
    }

    CanSave() {
        return this.SelectedConfiguration
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.SelectedConfiguration);

    }
}
